import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrCard from 'client/components/SrCard/SrCard';
import SrButton, { SR_BUTTON_THEME_ADOBE_BLUE } from 'client/components/SrButton/SrButton';
import SrFlex from 'client/components/SrFlex';
import SrText from 'client/components/SrText';

import SimpleCoverBadge from './SimpleCoverBadge';

const UPTenantLiabilityBannerCard = ({ onEnableClick }) => {
  return (
    <SrCard padding="24px" margin="0 0 32px">
      <SrFlex align="center" justify="center">
        <SrBox width="100%">
          <SrBox marginBottom="8px">
            <SimpleCoverBadge />
          </SrBox>

          <SrBox textAlign="left" marginBottom="6px">
            <SrText font="greycliff" size="26" weight="600" lineHeight="33px" color="blue300">
              Tenant Liability Protection
            </SrText>

            <SrText
              font="greycliff"
              size="26"
              weight="600"
              lineHeight="33px"
              color="blueGreycliffText"
            >
              {' for your tenants.'}
            </SrText>
          </SrBox>

          <SrBox marginBottom="12px">
            <SrText font="greycliff" size="16" weight="700" lineHeight="24px" color="#132630">
              Only 30 seconds to offer tenants
            </SrText>
            <br />

            <SrText font="greycliff" size="16" weight="700" lineHeight="24px" color="#00a238">
              $100k coverage
            </SrText>

            <SrText font="greycliff" size="16" weight="700" lineHeight="24px" color="#132630">
              {' for $16/month.'}
            </SrText>
          </SrBox>

          <SrFlex align="center" columnGap="24px">
            <SrBox flex="1 1 auto">
              <SrButton
                minWidth="auto"
                theme={SR_BUTTON_THEME_ADOBE_BLUE}
                onClick={onEnableClick}
                hasBoxShadow
              >
                Enable now
              </SrButton>
            </SrBox>
          </SrFlex>
        </SrBox>
      </SrFlex>
    </SrCard>
  );
};

UPTenantLiabilityBannerCard.propTypes = {
  onEnableClick: PropTypes.func.isRequired,
};

UPTenantLiabilityBannerCard.displayName = 'UPTenantLiabilityBannerCard';

export default UPTenantLiabilityBannerCard;
